export default {
  generic_error: 'Coś poszło nie tak',
  address_not_found:
    'Przepraszamy, nie znaleźliśmy tego adresu. Spróbuj ponownie, wpisując najpierw ulicę w polu wyszukiwania.',
  internal_error:
    'Niestety, wystąpił nieoczekiwany problem z Twoim zamówieniem. Nasz zespół techniczny już nad tym pracuje 🛠️.',
};
